// extracted by mini-css-extract-plugin
export var Top = "Job-module--Top--dwiYT";
export var Inner = "Job-module--Inner--Vtn6Q";
export var Content = "Job-module--Content--jBjz3";
export var Title = "Job-module--Title--iVUsc";
export var Text = "Job-module--Text--ELdpq";
export var Btn = "Job-module--Btn--ntjxB";
export var ImageWrap = "Job-module--ImageWrap--GIQmb";
export var arrowLeft = "Job-module--arrowLeft--VATZa";
export var arrowRight = "Job-module--arrowRight--p9edc";